<div class="card bg-semiblack/50 text-white backdrop-blur-sm gap-y-3">

    <p id="description" class="text-xs leading-5" [innerHTML]="descriptions.publicDescription"></p>

</div>